<template>
  <div class="menuBody" >
    <div class="menuTool" style="width:100%;">
        <pollingTree @pollingTree="getMsgFormSon" />
         <LevelManagementDialog @dialogVisible="dialog"  ref="LevelManagementDialog"/>
         <BulkPrintDialog  ref="BulkPrintDialog"/>
      <el-card class="box-card">
        <el-row :gutter="10">
            <div style="width:100%;height:30px;margin-top:10px;border-bottom:1px solid rgba(234, 237, 241, 1);margin-bottom:15px">
                巡检点位列表
              <div style="float:right;margin-right:10px;margin-top:-10px">
               <el-button type="primary"  size="small" plain style="background: #38A38A;color:#fff;border-radius:9px;" @click="PropertyAdd()">巡检点位添加</el-button>
            </div>
             <div style="float:right;margin-right:10px;margin-top:-10px">
               <el-button type="primary"  size="small" plain style="background: #38A38A;color:#fff;border-radius:9px;" @click="BulkPrint()">批量打印二维码</el-button>
            </div>
            </div>
            <div style="width:150px;float:left;margin-right:15px">
                 <el-input placeholder="请输入点位编码" size="small"    v-model="InodeCode"></el-input>
            </div>
               <div style="width:150px;float:left;margin-right:15px">
                  <el-select  clearable v-model="value" size="small"  @change="SubordinateChange(value)" placeholder="请选择所属系统">
                      <el-option
                      v-for="item in SubordinateList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                      </el-option>
                  </el-select>
              </div>
                <div style="width:170px;float:left;margin-right:15px">
                 <el-select  clearable v-model="PointTypevalue" size="small"  @change="PointTypeChange(PointTypevalue)" placeholder="请选择点位类型">
                    <el-option
                    v-for="item in PointTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
              </div>
             <div style="float:right;margin-right:15px;">
                <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" @click="Inquire()">查询</el-button>
            </div>	
    <el-table  :data="tableData"  v-loading="loading"  tooltip-effect="light"    style="margin-bottom: 20px;overflow-y: scroll;float:right;margin-top:30px" row-key="id"   :header-cell-style="{background:'#eef1f6',color:'#606266','font-weight': '600','height':'45px','text-align':'left'}" 
      :cell-style="{'text-align':'left'}"  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
        <el-table-column show-overflow-tooltip prop="projectName" label="所属项目"  ></el-table-column>
        <el-table-column show-overflow-tooltip prop="spotName" label="点位名称"  ></el-table-column>
        <el-table-column show-overflow-tooltip prop="spotCode" label="点位编码" ></el-table-column>
        <el-table-column show-overflow-tooltip prop="field" label="点位类型" ></el-table-column>
        <el-table-column show-overflow-tooltip prop="fields" label="所属系统" ></el-table-column>
        <el-table-column show-overflow-tooltip prop="location" label="位置" ></el-table-column>
        <el-table-column show-overflow-tooltip prop="insNum" label="巡检次数" ></el-table-column>
        <el-table-column show-overflow-tooltip prop="insTime" label="间隔时间" ></el-table-column>
        <el-table-column fixed="right" label="操作" width="150px">
        <template slot-scope="scope">
            <el-button @click="QRcode(scope.row)" type="primary" icon="el-icon-full-screen" circle size="small" title="二维码"></el-button>
            <el-button @click="editMenu(scope.row)" type="primary" icon="el-icon-edit" circle size="small" title="修改"></el-button>
            <el-button @click="delMenu(scope.row)" type="danger" icon="el-icon-delete" circle size="small" title="删除"  v-debounce></el-button>
            </template>
        </el-table-column>
    </el-table>
          <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px;">
    </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import LevelManagementDialog from '../pollingCommon/LevelManagementDialog.vue'
import BulkPrintDialog from '../pollingCommon/BulkPrintDialog.vue'
import pollingTree from "../pollingCommon/pollingTree.vue";
export default {
  name: "LevelManagement",
  components: {LevelManagementDialog,pollingTree,BulkPrintDialog},
  data() {
    return {
        total:0,//默认数据总数
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        loading:false,
        classifyName:"",
        tableData:[],
        SubordinateList:[],
        value:"",
        valueName:"",
        PointTypeList:[],
        PointTypevalue:"",
        PointTypeName:'',
        InodeCode:"",
        orgId:"",

        AreaData:[],
        orgIdS:"",
        orgIdT:"",

    }
  },
  methods: {
    handleSizeChange(val) {
        this.pagesize  = val
        this.InitialQuery()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.InitialQuery()
    },
    dialog(data){
      if(data==false){
        this.InitialQuery()
      }
    },
    InitialQuery(){
    // 列表
      let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "orgId":this.orgId,
      }
      this.$http.post(this.$requestUrl.POST_SPOT_LIST,PageSize).then((res) => {
      let data = res.data
      if(data.code == 200){
        this.tableData = data.data.records
        this.total = data.data.total
      }else{
        this.$message.error(data.msg)
      }
    }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
    })
    },
    PropertyAdd(){
    // 添加
        let obj = {}
        this.$refs.LevelManagementDialog.title = "添加巡检点位";
        this.$refs.LevelManagementDialog.dialogVisible = true;
        this.$refs.LevelManagementDialog.formLabelAlign = obj
        this.$refs.LevelManagementDialog.SubordinateList = this.SubordinateList
        this.$refs.LevelManagementDialog.ifelse = "1"
        this.$refs.LevelManagementDialog.orgIdS = this.orgId
    },
    BulkPrint(){
        // 批量打印二维码
        let obj = {}
        this.$refs.BulkPrintDialog.title = "批量打印二维码";
        this.$refs.BulkPrintDialog.dialogVisible = true;
        this.$refs.BulkPrintDialog.formLabelAlign = obj
        this.$refs.BulkPrintDialog.classificationList = this.AreaData
    },
    editMenu(row){
    // 修改
        this.$refs.LevelManagementDialog.title = "修改巡检点位";
        this.$refs.LevelManagementDialog.dialogVisible = true;
        this.$refs.LevelManagementDialog.formLabelAlign = row
        this.$refs.LevelManagementDialog.SubordinateList = this.SubordinateList
        this.$refs.LevelManagementDialog.value = row.fields
        this.$refs.LevelManagementDialog.rowId = row.spotId
        this.$refs.LevelManagementDialog.PointTypevalue = row.field
        this.$refs.LevelManagementDialog.Classifyvalue = row.projectId
        this.$refs.LevelManagementDialog.ifelse = "1"
        this.$refs.LevelManagementDialog.projectId = row.projectId
    },
    delMenu(row){
    // 删除 DELETE_GET_SPOT6
        this.$confirm('是否确认要删除该标准?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.get(this.$requestUrl.DELETE_GET_SPOT+row.spotId).then((res) => {
          let data = res.data
          if(data.code == 200){
            this.currentPage = 1
            this.InitialQuery()
            }else{
              this.$message.error(data.msg)
            }
            })
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });

    },
    Inquire(){
    // 查询
      let obj = {
        "spotCode":this.InodeCode,
        "fields":this.valueName,
        "field":this.PointTypeName,
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "orgId":this.orgId,
        }
        if(obj.orgId == ""){

        }else{
            this.$http.post(this.$requestUrl.POST_SPOT_LIST,obj).then((res) => {
                let data = res.data
                if(data.code == 200){
                  this.tableData = data.data.records
                  this.total = data.data.total
                }else{
                  this.$message.error(data.msg)
                }
            }).catch(() => {
                    this.$message.error(this.$errorMessage.SEVER_ERROR)
            })
        }
    },
    QRcode(row){
        // 二维码
         this.$http.get("/inspect/spot/getErcode?spotId="+row.spotId).then((res)=>{
           let data = res.data
              if(data.code == 200){
                  this.$refs.LevelManagementDialog.title = "查看二维码";
                  this.$refs.LevelManagementDialog.dialogVisible = true;
                  this.$refs.LevelManagementDialog.PTcode = res.data.data.spotCode;
                  this.$refs.LevelManagementDialog.PTname = res.data.data.spotName;
                  this.$refs.LevelManagementDialog.PTitemName = res.data.data.projectName;
                  this.$refs.LevelManagementDialog.ifelse = "2"
                  this.$refs.LevelManagementDialog.PTtext = res.data.data.ramark;
              }else{
                this.$message.error(data.msg)
              }
        }).catch(() => {
            this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
    },
    SubordinateChange(res){
      for(let val of this.SubordinateList){
        if(val.value == res){
          this.valueName = val.label
              this.$http.get("/inspect/stand/getSpotType?system="+val.label).then((res)=>{
              let data = res.data
              let arr = []
              if(data.code == 200){
                for(let i = 0;i<data.data.length;i++){
                  let obj = {
                    "value":i,
                    "label":data.data[i]
                  }
                  arr.push(obj)
                }
                this.PointTypeList = arr
              }else{
                this.$message.error(data.msg)
              }
              })
        }
      }
    },
    PointTypeChange(res){
      for(let val of this.PointTypeList){
        if(val.value == res){
          this.PointTypeName = val.label
        }
      }
    },
    getMsgFormSon(data){
      if(data.orgId == null){
        this.orgId = data.id
        this.orgIdS = data.id
      }else{
        this.orgId = data.orgId
      }
        this.InitialQuery()
    },

    Subordinate(){
      this.$http.get("/inspect/stand/getAllSystem").then((res)=>{
      let data = res.data
      let arr =[]
      if(data.code == 200){
        for(let i = 0;i<data.data.length;i++){
          let obj = {
            "value":i,
            "label":data.data[i]
          }
          arr.push(obj)
        }
        this.SubordinateList = arr
      }else{
         this.$message.error(data.msg)
      }
      })
    },
    AreaList(){
       this.$http.get(this.$requestUrl.GET_AREA_LIST).then((res)=>{
      if(res.data.code == 200){
        let data = res.data.data
        this.AreaData = data
      }else{
         this.$message.error(data.msg)
      }
      }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
     })
    },





  },
  mounted() {
    this.Subordinate()
    this.AreaList()
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;

    }
  }

}
</style>